"use client";
import { useEffect, useRef, useState } from "react";
import { Skeleton } from "@/components/ui/skeleton";
import { requireEnv } from "@/lib/env";

export const REFER_A_FRIEND_SLUG = "refer-a-friend";

const SORETO_SDK_ID = "soreto-sdk";
const SORETO_SDK_SRC = "https://api.soreto.com/scripts/soreto.min.js";

export default function SoretoReferAFriend() {
  const widgetRef = useRef<HTMLDivElement>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    window.SORETO = {
      Client: { id: requireEnv(process.env.NEXT_PUBLIC_SORETO_CLIENT_ID, "NEXT_PUBLIC_SORETO_CLIENT_ID") },
      User: {},
      Widget: { showWidget: true, widgetType: "sharestaticpage" },
      sourceTag: "STATIC_PAGE_ON_CLIENT",
    };

    if (!document.getElementById(SORETO_SDK_ID)) {
      const script = document.createElement("script");
      script.id = SORETO_SDK_ID;
      script.src = SORETO_SDK_SRC;
      script.async = true;
      document.body.appendChild(script);
    }

    const widget = widgetRef.current;
    let observer: MutationObserver | undefined;
    if (widget?.childElementCount) {
      setLoading(false);
    } else if (widget) {
      observer = new MutationObserver(() => {
        if (widget.childElementCount) {
          setLoading(false);
          observer?.disconnect();
        }
      });
      observer.observe(widget, { childList: true, subtree: true });
    }

    const handler = (e: MessageEvent) => {
      if (e.data === "move-top") {
        window.scrollTo({ top: 0, behavior: "smooth" });
      }
    };
    window.addEventListener("message", handler);
    return () => {
      window.removeEventListener("message", handler);
      observer?.disconnect();
    };
  }, []);

  return (
    <div
      id="soretoStaticPageDiv"
      className="mx-auto w-full max-w-site-content px-6 pt-6 text-center [&_.reverb-static-lightbox]:mx-auto [&_.reverb-static-lightbox]:inline-block [&_.reverb-static-lightbox]:h-450! [&_.reverb-static-lightbox]:w-full [&_.reverb-static-lightbox]:max-w-360! min-[601px]:[&_.reverb-static-lightbox]:h-512.5! lg:[&_.reverb-static-lightbox]:h-457.5!"
    >
      {loading && (
        <Skeleton
          className="mx-auto h-450 w-full max-w-360 min-[601px]:h-512.5 lg:h-457.5"
          aria-label="Loading"
          aria-live="polite"
          aria-busy="true"
        />
      )}
      <div id="soretosharewidget" ref={widgetRef} />
    </div>
  );
}
